// Shared option lists for ticket filter/select fields.

export const STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "Open", label: "Open" },
  { value: "Assigned", label: "Assigned" },
  { value: "In Progress", label: "In Progress" },
  { value: "Resolved", label: "Resolved" },
  { value: "Closed", label: "Closed" },
];

export const PRIORITY_OPTIONS = [
  { value: "", label: "All Priorities" },
  { value: "Critical", label: "Critical" },
  { value: "High", label: "High" },
  { value: "Medium", label: "Medium" },
  { value: "Low", label: "Low" },
];

export const CATEGORY_OPTIONS = [
  { value: "", label: "All Categories" },
  { value: "Hardware", label: "Hardware" },
  { value: "Software", label: "Software" },
  { value: "Network", label: "Network" },
];

export const SORT_OPTIONS = [
  { value: "", label: "Default" },
  { value: "Newest", label: "Newest First" },
  { value: "Oldest", label: "Oldest First" },
];
